import { render, staticRenderFns } from "./JGrid.vue?vue&type=template&id=1c59792d&scoped=true&"
import script from "./JGrid.vue?vue&type=script&lang=ts&"
export * from "./JGrid.vue?vue&type=script&lang=ts&"
import style0 from "./JGrid.vue?vue&type=style&index=0&id=1c59792d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c59792d",
  null
  
)

export default component.exports